var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"headForm"},[_c('a-tabs',{on:{"change":_vm.callback}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"肉禽"}},[_c('meat')],1),_c('a-tab-pane',{key:"2",attrs:{"tab":"蛋禽","force-render":""}},[_c('egg')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }